export type ExtensionErrorName =
  | 'HOME_SCREEN_NOT_FOUND'
  | 'NOT_LOGGED_IN'
  | 'SOAP_TEMPLATE_NOT_FOUND'
  | 'NOTE_EDITOR_NOT_FOUND'
  | 'FAILED_TO_SIGN'
  | 'GENERIC_ERROR'
  | 'TIMEOUT'
  | 'FAILED_TO_IMPORT'
  | 'TEMPLATE_NOT_SUPPORTED'
  | 'STAFF_MISMATCH'
  | 'INVALID_STATE_PAGE_REFRESH_REQUIRED'
  | 'MIC_DISCONNECTED'
  | 'MIC_PERMISSIONS_DENIED'
  | 'DOM_INJECTION_FAILED'
  | 'PATIENT_DELETED'
  | 'APPOINTMENT_NOT_FOUND'
  | 'USER_ID_MISMATCH'
  | 'EXTENSION_CONNECTION_LOST'
  | 'INSUFFICIENT_STORAGE'
  | 'APPOINTMENT_ALREADY_SIGNED';

export const ERRORS: Record<ExtensionErrorName, ExtensionErrorName> = {
  HOME_SCREEN_NOT_FOUND: 'HOME_SCREEN_NOT_FOUND',
  NOT_LOGGED_IN: 'NOT_LOGGED_IN',
  SOAP_TEMPLATE_NOT_FOUND: 'SOAP_TEMPLATE_NOT_FOUND',
  NOTE_EDITOR_NOT_FOUND: 'NOTE_EDITOR_NOT_FOUND',
  FAILED_TO_SIGN: 'FAILED_TO_SIGN',
  GENERIC_ERROR: 'GENERIC_ERROR',
  TIMEOUT: 'TIMEOUT',
  FAILED_TO_IMPORT: 'FAILED_TO_IMPORT',
  TEMPLATE_NOT_SUPPORTED: 'TEMPLATE_NOT_SUPPORTED',
  STAFF_MISMATCH: 'STAFF_MISMATCH',
  INVALID_STATE_PAGE_REFRESH_REQUIRED: 'INVALID_STATE_PAGE_REFRESH_REQUIRED',
  MIC_DISCONNECTED: 'MIC_DISCONNECTED',
  MIC_PERMISSIONS_DENIED: 'MIC_PERMISSIONS_DENIED',
  DOM_INJECTION_FAILED: 'DOM_INJECTION_FAILED',
  PATIENT_DELETED: 'PATIENT_DELETED',
  APPOINTMENT_NOT_FOUND: 'APPOINTMENT_NOT_FOUND',
  USER_ID_MISMATCH: 'USER_ID_MISMATCH',
  EXTENSION_CONNECTION_LOST: 'EXTENSION_CONNECTION_LOST',
  INSUFFICIENT_STORAGE: 'INSUFFICIENT_STORAGE',
  APPOINTMENT_ALREADY_SIGNED: 'APPOINTMENT_ALREADY_SIGNED',
};
